export default __webpack_public_path__ + "static/media/ruby.58fea0b9.png";